import React from 'react';
import { useSearchParams } from 'react-router-dom';
import icons from 'src/icons';

import { Button } from '@alfalab/core-components/button';

import { SystemMessageItem } from '../alert-message-modal/elems/system-message-item';

import { ErrorMessages } from './error-messages';

export const ErrorContainer = () => {
    const { origin } = window.location;

    const [searchParams] = useSearchParams();

    const error = searchParams.get('errorcode') || '';
    const errorCode = parseInt(error, 10);

    const errorMessage = ErrorMessages[Number(errorCode)] ? ErrorMessages[errorCode] : '';

    const handleClick = () => {
        // Удаляем куки и переадресовываем на главную страницу.
        // Это требование F5 для создания новой сессии и запуска повторного цикла авторизации
        document.cookie.split(';').forEach((c) => {
            document.cookie = c
                .replace(/^ +/, '')
                .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
        window.location.replace(origin);
    };

    return (
        <div className='authForm'>
            <SystemMessageItem
                title='Access was denied by the access policy.'
                subTitle={errorMessage}
                icon={icons.ForbiddenIcon}
            >
                <Button size='s' view='primary' onClick={handleClick}>
                    Понятно
                </Button>
            </SystemMessageItem>
        </div>
    );
};
